import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MediumUploadDTOAndTags } from 'src/app/models/taggable.model';
import { TagService } from 'src/app/services/tag.service';
import { UtilService } from 'src/app/services/util.service';
import { ResolutionDTO } from '../../../../../services/api/api';
import { PermissionService } from '../../../../../services/permission.service';

@Component({
  selector: 'sb-comp-medium-card-entry',
  templateUrl: './medium-card-entry.component.html',
  styleUrls: ['./medium-card-entry.component.scss'],
  standalone: false,
})
export class MediumCardEntryComponent implements OnInit {
  @Input() medium: MediumUploadDTOAndTags;
  @Input() divNgClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() resolutionOptions: ResolutionDTO[];
  @Input() multiSelect: boolean;
  @Input() isSelected: boolean;
  @Input() isInFolderContext: boolean = false;

  @Output() selectEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() dragendEmitter: EventEmitter<any>;
  @Output() dragstartEmitter: EventEmitter<{ event: DragEvent; item: MediumUploadDTOAndTags }>;

  displayNoMatching: boolean;

  constructor(
    public util: UtilService,
    public tagService: TagService,
    public permissionService: PermissionService
  ) {
    this.isSelected = false;
    this.multiSelect = false;
    this.dragendEmitter = new EventEmitter<any>();
    this.dragstartEmitter = new EventEmitter<{ event: DragEvent; item: MediumUploadDTOAndTags }>();
    this.displayNoMatching = true;
  }

  ngOnInit(): void {
    this.displayNoMatching = this.displayNoMatchingMarker();
  }

  displayNoMatchingMarker(): boolean {
    if (this.medium && this.medium.resolution && this.resolutionOptions && this.resolutionOptions.length > 0) {
      for (const resolution of this.resolutionOptions) {
        if (resolution.id === this.medium.resolution.id) {
          return false;
        }
      }
    }
    return true;
  }
}
